// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig : {
    apiKey: "AIzaSyBMd9pY-xb4WTfrNDzyIUPsI1HmDNXuESs",
    authDomain: "tfg-planificaciones.firebaseapp.com",
    databaseURL: "https://tfg-planificaciones.firebaseio.com",
    projectId: "tfg-planificaciones",
    storageBucket: "tfg-planificaciones.appspot.com",
    messagingSenderId: "105859117075",
    appId: "1:105859117075:web:e48c046d915f53f2580fe6"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
